type MovementDirection = "up" | "down" | "none";

export type LineMovement = {
  direction: MovementDirection;
  delta: number;
};

function profitPerDollar(american: number): number {
  return american >= 0 ? american / 100 : 100 / Math.abs(american);
}

export function computeMovement(
  previous: number,
  current: number
): LineMovement {
  if (previous === 0 || current === 0) {
    return { direction: "none", delta: 0 };
  }

  const delta = Math.abs(current - previous);

  if (delta < 0.5) {
    return { direction: "none", delta: 0 };
  }

  const previousProfit = profitPerDollar(previous);
  const currentProfit = profitPerDollar(current);

  if (currentProfit === previousProfit) {
    return { direction: "none", delta: 0 };
  }

  const direction: MovementDirection =
    currentProfit > previousProfit ? "up" : "down";

  return { direction, delta: Math.round(delta) };
}

